import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Store, Building2, Users } from "lucide-react";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] } }),
};

const ICONS = [Store, Building2, Users];

export default function Audiences() {
  const { t } = useLang();
  return (
    <section id="canali" className="pt-[50px] pb-10 md:pt-[82px] md:pb-14 bg-white border-t border-ink/80">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-ferrari">{t.audiences.label}</span>
            <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-[0.9]">
              {t.audiences.titleA}<br /><span className="text-ferrari">{t.audiences.titleB}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-ink/65 text-base md:text-lg leading-relaxed">{t.audiences.intro}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4">
          {t.audiences.channels.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
                data-testid={`channel-card-${i}`}
                className="group relative border border-ink/80 bg-white p-7 md:p-9 min-h-[280px] flex flex-col hover:bg-ink hover:text-white transition-colors duration-300 rounded-2xl"
              >
                <Icon size={34} strokeWidth={1.5} className="text-ferrari" />
                <div className="mt-8">
                  <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-ferrari">{c.tag}</span>
                  <h3 className="font-display font-extrabold uppercase tracking-tight text-2xl md:text-3xl mt-2 leading-none break-words hyphens-auto min-h-[3rem] md:min-h-[3.75rem]">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/60 group-hover:text-white/70 transition-colors duration-300">{c.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
